import { LandingPointBase } from './base/landing-point-base';

export class LandingPoint extends LandingPointBase { }